<script>
  import Headline from './components/headline.svelte'
  import Shelf from './components/shelf.svelte'
</script>

<main class="mb-[128px] mt-[122px]">
  <Headline />
  <Shelf />
</main>
